
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M6.9 4.9V0h-2v4.9H0v2h4.9V12h2V6.9H12v-2z"/>'
  }
})
